module.exports = __webpack_public_path__ + "img/Image Container (2).c8ef6ff7.png";